import {
    Log, LogLevel,
} from 'one-log';

import {
    init,
} from 'ccw-app';

import {
    loader,
} from 'one-web-loader';
import { enableTrace } from "one-trace";

import {
    AlertNotification
} from "one-alert-notification";

import {
    BrowserLogger,
} from 'one-web-logger';
import { HAServer, HAServerOne } from 'one-server-local-ha';
import logo from "./logo.png";
//import addNotification from 'react-push-notification';

// set up the logger
const log = new Log("ccw-app", [
    new BrowserLogger(),
], LogLevel.DEBUG);

loader({
    log,
    url: 'settings.json',
}, (options: any) => (
    new Promise(async (resolve) => {
        const {
            settings,
            resolver,
        } = options;

        /**
         * check for the log level config from settings and set default
         */
        const { logconfig, alertnotify, toaster_notification, compatible : { consolidated_api_invocation } } = settings;
        if (logconfig?.level === "INFO") {
            log.setlevel(LogLevel.INFO);
        } else if (logconfig?.level === "WARN") {
            log.setlevel(LogLevel.WARN);
        } else if (logconfig?.level === "ERROR") {
            log.setlevel(LogLevel.ERROR);
        } else {
            log.setlevel(LogLevel.DEBUG);
        }
        // log.debug(
        //     'ccw-app-web',
        //     'app settings', {
        //     settings,
        // });

        // logged in agent id
        const agentId = '';
        // adding ani
        const ani = '';
        let alertnotification = new AlertNotification(false, alertnotify?.url, {
        });
        if (alertnotify?.enable) {
            alertnotification = new AlertNotification(true, alertnotify?.url, {
                customer_name: alertnotify?.customer,
                server_id: alertnotify?.servername,
                app_type: "web"
            })
        }
        // enable user specific trace
        enableTrace(agentId, {
            log,
            settings,
        });
        const Notify = (message: any) => {
            // console.log('TN::Win', message);
            let notify = new Notification("", {
                body : message,
                icon: resolver(logo)
                //timestamp: toaster_notification?.notification_time_duration
            });
            notify.onclick = (e) => {
                window.focus();
            }
            notify.onshow = function () {
                setTimeout(()=>{
                    notify.close();
                }, toaster_notification?.notification_time_duration);
            }
        }
        // const ReactNotify = (options: any) => {
        //     console.log('TN::React',toaster_notification?.notification_time_duration);
        //     addNotification({
        //         title: ' ',
        //         message: options,
        //         native: true, // when using native, your OS will handle theming.
        //         onClick: (e: any) => {
        //             window.focus()
        //         },
        //         icon: resolver(logo),
        //         duration: toaster_notification?.notification_time_duration
        //     });
        // }
        /**
         * When dashboard gets loaded ask for Notification Permission to user
         */
        if(Notification.permission === 'denied' || Notification.permission === 'default'){
            Notification.requestPermission().then(permission => {
                log.debug('Notification Permission ',permission);
            })
        }

        const server = new HAServer(
            settings['servers'],
            (url: string, error: any) => {
                store.dispatch({
                    type: "one-state-errorhandle/set",
                    payload: {
                        url: url,
                        error: error,
                        monitor: false
                    }
                })
            }
        );

        const serverone = new HAServerOne(
            settings['servers'],
            (url: string, error: any) => {
                store.dispatch({
                    type: "one-state-errorhandle/set",
                    payload: {
                        url: url,
                        error: error,
                        monitor: false
                    }
                })
            }
        );
 
      
        // var crmApi = window.VonageDialer.CrmSdk.crmApi();
        // var interactionApi = window.VonageDialer.init({},(dialer)=>{
        //     console.log(dialer,"dialer")
        // });

        // initialize the app
        const {
            store,
        } = await init('app', {
            log,
            agentId,
            ani,
            settings,
            resolver,
            alertnotification,
            server,
            serverone,
            // interactionApi,
        });
            // console.log(store,"init func")
        resolve({
            log,
            // next is optional
            next: (params: any) => {
                console.debug(
                    'ccw-app-web',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({
                    store,
                });
            },
        });



        window.VonageDialer.enableClickToDial(true);
        window.VonageDialer.init({debug:true},(dialer:any)=>{
          




            dialer.setOnDialerEvent((e:any)=>{

                     let stateobj = store.getState();
                    //  let interactionId="01806560-9346-43ec-ba70-5f2a1a5b9ecd";
                    //  let number:any="2158821126";
                    //  let showVerificationModal: boolean = false;
                    //  let subjectId:any;
                    //  let sourceId:any;
                    //  let dnis="4152361759"
                     let interactionId=e.data?.vcc?.vonageccguid;
                     let number:any=e.data.phoneNumber;
                     let showVerificationModal: boolean = false;
                     let subjectId:any;
                     let sourceId:any;
                     let dnis=e.data.did;
                     let vonageagentid=e?.data?.vcc?.vonageagentid;
         
                     const killnotification = stateobj?.vonageNotification?.vonagenotification;
                     
                     switch (e.type) {
                         case 'CALL_START': {
                             console.log('CALL_START',e)
                             ///call controls getsession
                             
                             //Dispatch GetSession
                             store.dispatch({
                                 type: "one-state-getsession/fetch",
                                 payload: {
                                     sessionKey:interactionId
                                 }
                             });

                            ///call controls getsession

                             sessionStorage.setItem("vonage_userid",vonageagentid);
                           sessionStorage.setItem("vonageInteractionId",interactionId);
                           if(
                           (e.data?.direction === 'INBOUND' || e.data?.direction === 'INTERNAL') &&
                           toaster_notification?.inbound_call_notification && 
                           killnotification){
                              Notify("Incoming Call ("+ number +")");
                          }
                          if(  e.data?.direction === 'OUTBOUND' && 
                            toaster_notification?.outbound_call_notification && 
                            killnotification){
                              Notify("Outgoing Call ("+ dnis +")");
                          }
                           if(number.length>10){
                            number=number.slice(2,12);
                        }
                        if(e.data.direction=="INBOUND"){
                        if(dnis.length>10){
                            dnis=dnis.slice(1,11);
                        }
                    }
                    else{
                        dnis=dnis.slice(2,12);
                    }
                    showVerificationModal=true;
                    store.dispatch({
                     type: "one-state-choosecaller/set",
                     payload: {
                         number,
                         dnis,
                         visible: showVerificationModal,
                         start: true
                     }
                 });
                           store.dispatch({
                            type: "interact-vonage-set-interaction-id",
                            payload: interactionId,
                            });
                            store.dispatch({
                                type: "interact-vonageagentId-set",
                                payload:vonageagentid
                                });
                            // store.dispatch({
                            // type: "caller-patient",
                            // payload: {
                            //     number,
                            //     dnis,
                            //     subjectid: subjectId ? subjectId.value : null,
                            //     sourceid: sourceId ? sourceId.value : null,
                            //  }
                            // });
                            let skeleton: {
                                source_skeleton: true,
                                subject_skeleton: true,
                                callingDestination_skeleton: true
                            }
                            store.dispatch({
                                type: "one-state-skeleton/set",
                                payload: skeleton
                            });
                            sessionStorage.setItem("ani", number);
                        sessionStorage.setItem("dnis", dnis);
                         break;
                       }
                       case 'CALL_ANSWER': { // available only for UC
                        if (Notification.permission === 'granted' && e.data?.direction === 'OUTBOUND' &&
                        toaster_notification?.outbound_call_notification &&
                        toaster_notification?.outbound_call_epic_count_notification &&
                        killnotification) {
                        setTimeout(() => {
                            const patientcount = stateobj?.subjectstore?.values;
                            const count = (patientcount === undefined || patientcount === 'undefined' || patientcount === null) ? 0 : patientcount?.length;
                            Notify("Outgoing Call (" + dnis + ")          " + count + " Matches ");
                        }, 4000);
                    }
                    if (Notification.permission === 'granted' &&
                        (e.data?.direction === 'INBOUND' || e.data?.direction === 'INTERNAL') &&
                        toaster_notification?.inbound_call_notification &&
                        toaster_notification?.inbound_call_epic_count_notification &&
                        killnotification) {
                        setTimeout(() => {
                            const patientcount = stateobj?.subjectstore?.values;
                            const count = (patientcount === undefined || patientcount === 'undefined' || patientcount === null) ? 0 : patientcount?.length;
                            Notify("Incoming Call (" + number + ")     " + count + " Matches ");
                        }, 4000);
                    }
                         break;
                       }
                       case 'CALL_END': {
                         // do something based on event.data (screen pop, store interaction, etc.)
                         if(Notification.permission === 'granted' &&
                         (e.data?.direction === 'INBOUND' || e.data?.direction === 'INTERNAL') &&
                         toaster_notification?.inbound_call_notification && 
                         killnotification){
                            Notify(" Incoming Call to ("+ number +") Ended");
                        }
                        if(  e.data?.direction === 'OUTBOUND' && 
                          toaster_notification?.outbound_call_notification && 
                          killnotification){
                            Notify("Outgoing Call to("+ dnis +") Ended");
                        }
                       
                        
                                    store.dispatch({
                                        type: "one-state-choosecaller/reset",
                                        payload: {
                                            number: '',
                                            dnis: '',
                                            visible: false,
                                            start: false
                                        }
                                    });
                                    store.dispatch({
                                        type: "one-state-tabs/set",
                                        payload: "1"
                                    })
                                    store.dispatch({
                                        type: "interact-vonage-reset",
                                        payload: ""
                                    })
                                   
                                    store.dispatch({
                                        type: "store-vonage-clicktodial-reset",
                                        payload: ""
                                    })
                                   
                                    store.dispatch({
                                        type: "one-state-subject/reset",
                                        payload: {
                                            number: '',
                                            dnis: ''
                                        }
                                        // payload:{
                                        //     values:[]
                                        // }
                                    });
                                    store.dispatch({
                                        type: "interact-vonageagentId-reset",
                                        payload: ""
                                        });
                                    
                                   
                                    sessionStorage.removeItem("subjectid");
                                    sessionStorage.removeItem("sourceid");
                                    sessionStorage.removeItem("ani");
                                    sessionStorage.removeItem("dnis");
                                    sessionStorage.removeItem("agentName");
                                    sessionStorage.removeItem("vonageInteractionId");
                                    sessionStorage.removeItem("vonage_userid");
                                    sessionStorage.removeItem("PatientName");



                         break;
                       }
                      
                       default: {
                         console.log('Unhandled event', e);
                         //capturing agint login and logout for hiding global search
                         if(e.type=== 'READY' || e.type==='HEALTH'){
                         store.dispatch({
                             type: "store-vonage-user-state",
                             payload: {userStates:true}
                         });
                         localStorage.setItem('VonageGlobal','true')
                        }
                        else if(e.type=== 'LOGOUT'){
                         store.dispatch({
                             type: "store-vonage-user-state-reset",
                             payload: {}
                         });
                         localStorage.removeItem('VonageGlobal')

                     }
                       }
                    }
                  
            })
        });
    })))

